<script setup>
import { useRouter } from "vue-router";
import AppDataTable from "@/components/AppDataTable.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useResourceList } from "@/composables/useResourceList";
import { fetchGuidePages, deleteGuidePage } from "./api";

const router = useRouter();
const columns = [
  { key: "title",   label: "Title",   sortable: true },
  { key: "actions", label: "Actions", align: "end", width: "150px" },
];
const { rows, loading, error, pendingDelete, deleting, load, askDelete, confirmDelete } =
  useResourceList({
    fetch: fetchGuidePages,
    remove: (id, row) => deleteGuidePage(id, row?.imageUrl),
    mapRow: (g) => ({ id: g._id, title: g.message?.title ?? g.title ?? "—", imageUrl: g.message?.imageUrl ?? g.imageUrl }),
  });
</script>

<template>
  <section>
    <div class="d-flex align-center justify-space-between mb-4 gap-3 flex-wrap">
      <h1 class="text-h5">Guide Pages</h1>
      <div class="d-flex gap-2">
        <VBtn variant="tonal" @click="load">Refresh</VBtn>
        <VBtn @click="router.push({ name: 'guide-pages-new' })">Add Guide Page</VBtn>
      </div>
    </div>
    <VAlert v-if="error" type="error" closable class="mb-4" @click:close="error = ''">{{ error }}</VAlert>
    <AppDataTable :columns="columns" :rows="rows" :loading="loading" row-key="id" searchable search-placeholder="Search guides…" empty-text="No guide pages yet.">
      <template #cell-actions="{ row }">
        <VBtn size="small" variant="text" @click.stop="router.push({ name: 'guide-pages-edit', params: { id: row.id } })">Edit</VBtn>
        <VBtn size="small" color="error" variant="text" @click.stop="askDelete(row)">Delete</VBtn>
      </template>
    </AppDataTable>
    <ConfirmDialog :model-value="pendingDelete !== null" title="Delete guide page?" :message="`Delete &quot;${pendingDelete?.title || 'this page'}&quot;?`" :loading="deleting" @update:model-value="pendingDelete = null" @confirm="confirmDelete" />
  </section>
</template>
